import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import dayjs from 'dayjs';
import downloadjs from 'downloadjs';
import html2canvas from 'html2canvas';
import * as React from 'react';
import PrintProvider, { Print } from 'react-easy-print';
import { AlumnoType } from '../../types/types';
import { monthToString } from '../../utils/utils';
import { ClosableTitle } from '../DialogTitle';
import { DeudaFamiliarType } from './DeudaReportFamiliar';
import { TablaFamiliarPagos } from './tablaPagosFamiliar';


interface ReciboProps {
  onClose: () => void;
  pagos: DeudaFamiliarType | null;
  alumno: AlumnoType;
}

export function ReciboFamiliar(props:ReciboProps) {
  const { alumno, onClose, pagos } = props;
  const fechaActual = dayjs().format('DD-MM-YYYY');
  const handleDownload = async () => {
    const reciboHTML = document.getElementById('recibo-familiar-component');
    if (!reciboHTML) return null;
    const canvas = await html2canvas(reciboHTML);
    const dataURL = canvas.toDataURL('image/png');
    downloadjs(dataURL, `recibo-familia-${alumno.apellido}-${fechaActual}.png`, 'image/png');
  };
  const date = pagos?.periodo.split('-');

  return (
    <div>
      <Dialog open={!!pagos} maxWidth={false}>
        <ClosableTitle id="recibo-dialog" onClose={onClose} transparent={false}>Descargar recibo</ClosableTitle>
        <DialogContent>
          {pagos && date && (
            <PrintProvider>
              <Print single name="printPartList">
                <div id="recibo-familiar-component" style={{ position: 'relative', padding: 16 }}>
                  <img src={process.env.PUBLIC_URL + '/logo.png'} style={{ width: 120, position: 'absolute', top: 10, right: 10 }} />
                  <Typography textAlign="center" fontWeight="bold" fontSize={20}>Recibo de pago</Typography>
                  <Typography>Generado el<strong>{` ${fechaActual}`}</strong></Typography>
                  <Typography>Familia:<strong>{` ${alumno.apellido}`}</strong></Typography>
                  <Typography>Periodo:<strong>{`${monthToString(Number(date[0]))} de ${date[1]}`}</strong></Typography>
                  <Typography textAlign="center">Detalle de pagos</Typography>
                  <div style={{ width: '100%' }}><TablaFamiliarPagos deudaFamiliar={pagos} /></div>
                </div>
              </Print>
            </PrintProvider>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={handleDownload}
          >
          Descargar
          </Button>
          <Button
            variant="contained"
            onClick={() => window.print()}
          >
          Imprimir
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );

}